import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_GAME } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Game',
        name: 'Game',
        icon: 'fas fa-dna'
    },
    {
        parent: 'Multiplayer.Game',
        key: 'Variant',
        name: 'Variant',
        icon: 'fas fa-shapes',
        route: { name: ROUTE_NAME_GAME.VARIANT.INDEX }
    },
    {
        parent: 'Multiplayer.Game',
        key: 'Match',
        name: 'Match',
        icon: 'fas fa-dollar-sign',
        route: { name: ROUTE_NAME_GAME.MATCH.INDEX }
    },
    {
        parent: 'Multiplayer.Game',
        key: 'Parameter',
        name: 'Parameter',
        icon: 'fas fa-sliders-h',
        route: { name: ROUTE_NAME_GAME.PARAMETER }
    },
    {
        parent: 'Multiplayer.Game',
        key: 'Report',
        name: 'Report',
        icon: 'far fa-file-alt',
        route: { name: ROUTE_NAME_GAME.REPORT }
    }
]);

export default registerRouteForModule(router);
